const logList = () => import('@/pages/permission/log/index.vue');

export default [{
    path: '/permission/log/list',
    component: logList,
    meta: [{
        name: '权限管理'
    },
    {
        name: '日志列表',
        activeRoute: '/permission/log/list'
    }]
}];